import { Auth } from 'aws-amplify'
import { toast } from 'react-toastify';

import { store } from '../store';
const baseApi = "/api"

export const secondaryApi = window.location.hostname === 'localhost' ?'http://localhost:3005': window.location.origin
    .replace('app.', 'api.')
    .replace('staging.','api-staging.')
    .replace('engine.internet', 'api.internet')

export const apiCall = async(url, options, token=null, base = baseApi, signal=null, overrideToken=null, disableContentType=false) => {
    let headers = {
        
    }

    const state = store.getState()

    if(!disableContentType){
        headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Client-Version': state.session.clientVersion
        }
    }
    headers['Authorization'] = 'Bearer ' + (overrideToken ? overrideToken : (token ? token :localStorage.getItem("token")))
    
    const opt = {
        ...options,
        body: disableContentType ? options.body : JSON.stringify(options.body),
        headers
    }

    if(signal){
        opt.signal = signal
    }
    try {
        const resp = await fetch(`${base}/${url}`, opt)
        .then(
            response => {
                if(options.method === "GET" && 
                        state.session.clientVersion !== null && 
                        response.headers.get("X-Client-Version") !== null && 
                        response.headers.get("X-Client-Version") !== state.session.clientVersion){
                    toast.warning("Platform version is not up-to-date. Refreshing now...")

                    setTimeout(() => {
                        window.location.reload()
                    }, 2000)
                }

                if(response.name === "AbortError"){
                    throw new Error("AbortError")
                }
                return (response.ok ? disableContentType ? response.arrayBuffer() : response.json() :
                Promise.reject(response)
                )
            },
            error => error
        )    
        .then(
            json => ({ response: json }),
            error => ({ error })
        )
        
        if(resp.error){
            if(resp.error.status === 401){
                throw new Error("Auth issue")                
            } else if(resp.error.status === 403){
                toast.error("Your access has been denied", {containerId: "defaultToastContainer"})
            }

        }

        return resp
    }
    catch(error) { 

        if (error.name === 'AbortError') {
            console.log("Request aborted");
            return;
        }

        try {
            const data = await Auth.currentSession()
            localStorage.setItem('token', data.idToken.jwtToken)
            
            headers['Authorization'] = 'Bearer ' + (overrideToken ? overrideToken : (localStorage.getItem("token") !== null ? localStorage.getItem("token") : token))
    
            const resp = await fetch(`${base}/${url}`, opt)
            .then(
                response => {
                    return (response.ok ? disableContentType ? response.arrayBuffer() : response.json() :
                    Promise.reject(response)
                    )
                },
                error => error
            )    
            .then(
                json => ({ response: json }),
                error => ({ error })
            )

            if(resp.error && (resp.error.status === 401)){
                throw new Error("Auth issue")
            }

            return resp
        } catch(e){
            toast.error("Your session has expired. Please login again")
            await Auth.signOut({ global: true })
            localStorage.removeItem('token')
            // setTimeout(async() => {
            //     window.location = '/'
            // }, 1500)
        }
    }
}